<template>
  <div>
    <template>
      <div>
        <v-card light>
          <v-system-bar dark color="grey darken-1" height="50">
            <v-btn
              outlined
              small
              fab
              dark
              class="transparent"
              @click.stop="$router.go(-1)"
            >
              <v-icon>mdi-arrow-left-circle</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            Dotations matériels et intrants
            <v-spacer></v-spacer>

            <v-btn
              outlined
              small
              fab
              dark
              class="transparent"
              @click.stop="$router.go(-1)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-system-bar>

       
          <v-card-text>
            <v-list two-line subheader>
              <v-list-item
                v-for="(dotation, index) in dotations"
                :key="index"
              >
                  <v-list-item-content>
                <v-list-item-title>{{
                  dotation.ll_dotation
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  dotation.date_dotation
                }}</v-list-item-subtitle>
                 <v-list-item-subtitle>Nombre de participants : {{
                  dotation.nombre_participants
                }}</v-list-item-subtitle>
                  </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon>
                    <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

        
          </v-card-text>
      
        </v-card>
      </div>
    </template>
      <Navigation :elements="SuperviseurNavigation" />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Dotation", value: "ll_dotation" },
        { text: "Participants", value: "nombre_participants" },
        { text: "Activité", value: "ll_parcours" },
        { text: "Date", value: "date_dotation" },
        { text: "Responsable", value: "nom_responsable" },
        {
          text: "Région",
          value: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
        },
        {
          text: "Thème",
          value: "ll_theme",
        },
      ],
    };
  },
  created() {
    this.GetDotationsDeSuperviseur(this.user.uid);
  },

  computed: {
    ...mapState({
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      user: (state) => state.Auth.user,
      dotations: (state) => state.Dotations.dotations,
    }),
  },
  methods: {
    ...mapActions({
      GetDotationsDeSuperviseur:
        "Dotations/GetDotationsDeSuperviseur",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
